import styled from 'styled-components';

export const ZapierTemplatesWrapper = styled.div.attrs({
  className: 'container',
})`
  h1 {
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 10px;
    color: #212529;
    padding-bottom: 10px;
    border-bottom: 1px solid #e9ecef;
  }

  p {
    font-size: 16px;
    font-weight: 400;
    margin-bottom: 10px;
  }
`;

export const AgencyDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
